<script setup>
  import { ref, watchEffect, useTemplateRef, watch } from 'vue';
  import PopupMenuController from "@/components/controls/PopupMenuController.vue";

  const emit = defineEmits(['popup:toggle']);

  const props = defineProps({
    id: {
      type: [String, Number],
      required: true
    },
    showPopupMenu: {
      type: Boolean,
      default: false
    },
    positionY: {
      type: String,
      default: 'top'
    },
    positionX: {
      type: String,
      default: 'right'
    },
    popupButtonRef: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: null
    },
    teleport: {
      type: Boolean,
      default: false
    }
  });

  const popupContainer = useTemplateRef('popup-container');
  const popupButton = useTemplateRef('popup-button');
  
  const showMenu = ref(false);
  const popupRect = ref({ x: 0, y: 0 });

  const togglePopupMenu = () => { 
    showMenu.value ? closePopupMenu() : openPopupMenu() 
  }
  
  async function openPopupMenu() {
    showMenu.value = true;

    emit('popup:toggle', showMenu.value);
  }
  
  function closePopupMenu() {
    showMenu.value = false;

    emit('popup:toggle', showMenu.value);
  };

  function getPopupContainerRect() {
    if (!popupContainer.value) return;

    const { x, y, width, height } = popupContainer.value.getBoundingClientRect();
    popupRect.value = { x, y, width, height };
  }

  watch(() => props.showPopupMenu, (newVal) => {
    if (newVal) {
      openPopupMenu();
    } else {
      closePopupMenu();
    }
  });

  watchEffect(() => {
    if (!popupContainer.value) return;

    getPopupContainerRect();

  }, { flush: 'post' });
</script>
<template>
  <div
    ref="popup-container"
    class="jwx-popup"
    >
      <button
        @keyup.esc="closePopupMenu"
        @click.prevent="togglePopupMenu"
        type="button"
        :aria-controls="`popup-menu-${id}`"
        :aria-expanded="showMenu"
        class="jwx-popup__wrapper-button"
        :disabled="props.disabled"
        ref="popup-button"
      >
        <slot name="button-content"></slot>
      </button>
      <slot name="misc"></slot>
      <slot name="menu" :showMenu="showMenu">
        <PopupMenuController
          v-if="showMenu"
          v-model="showMenu"
          :id="`popup-menu-${id}`"
          :positionY="props.positionY"
          :positionX="props.positionX"
          :popupRect="popupRect"
          :teleport="props.teleport"
          :button="props.popupButtonRef || popupButton"
        >
          <template #menu-content>
            <slot name="menu-content"></slot>
          </template>
        </PopupMenuController>
      </slot>
  </div>
</template>